import ChevronLeft from '@ixigo/icons/ChevronLeft';
import Collapse from '@ixigo/iui/Collapse';
import cn from '@repo/shared/utils/cn';
import { useState } from 'react';
import LineItem, { type LineItemProps } from './LineItem';

interface FareItemCollapsibleGroupProps
	extends React.ComponentPropsWithoutRef<'div'>,
		LineItemProps {
	children: React.ReactNode;
}

export function FareItemCollapsibleGroup(props: FareItemCollapsibleGroupProps) {
	const { children, label, value, className, ...rest } = props;
	const [expanded, setExpanded] = useState(false);
	return (
		<div className={cn('flex flex-col', className)} {...rest}>
			<LineItem
				label={label}
				value={value}
				rightIcon={
					<ChevronLeft
						className={cn(
							expanded ? 'rotate-90' : '-rotate-90',
							'transition-transform -mb-0.5',
						)}
					/>
				}
				className="cursor-pointer"
				onClick={() => setExpanded(!expanded)}
			/>
			<Collapse in={expanded}>
				<div className="flex flex-col">{children}</div>
			</Collapse>
		</div>
	);
}

interface FareItemGroupProps extends React.ComponentPropsWithoutRef<'div'> {
	children: React.ReactNode;
}

export function FareItemGroup(props: FareItemGroupProps) {
	const { children, className, ...rest } = props;
	return (
		<div
			className={cn('flex flex-col border-t border-tertiary pt-10', className)}
			{...rest}
		>
			{children}
		</div>
	);
}
